import { Separator } from "@radix-ui/react-separator";
import { Skeleton } from "Components/ui/skeleton";
import React from "react";
import { useSelector } from "react-redux";

function Statistics() {
  const { challengeCurrency } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );
  const { challengeStageInfoLoading } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );
  const {
    getStatisticsLoading,
    getStatisticsSuccess,
    getStatisticsError,
    statistics,
  } = useSelector((state) => state.ChallengePerformanceReducer);
  return (
    <div className="chart_cont bg-background border-2 border-border-darkNew rounded-lg h-full flex flex-col relative   p-4 justify-between flex-1">
      <div className="flex justify-between border-b-2 border-b-border-darkNew pb-4 mb-4">
        <div className="text-base">Statistics</div>
      </div>
      <div className="flex flex-col gap-4 h-full justify-between">
        <div className="flex flex-col  border-2 border-border-darkNew py-2 px-2 rounded-lg gap-2 flex-1 justify-center">
          <div className="text-white-opacity text-sm">
            {" "}
            Average Trade Duration
          </div>
          {getStatisticsLoading || challengeStageInfoLoading ? (
            <Skeleton className="w-16 h-6 " />
          ) : (
            <div className="text-white  text-base font-N_Bold">
              {statistics?.averageDuration || "-"}
            </div>
          )}
        </div>
        <div className="flex flex-col border-2 border-border-darkNew py-2 px-2 rounded-lg gap-2 flex-1 justify-center">
          <div className="text-white-opacity text-sm"> Average Daily P&L</div>
          {getStatisticsLoading || challengeStageInfoLoading ? (
            <Skeleton className="w-16 h-6 " />
          ) : (
            <div
              className="text-white  text-base font-N_Bold"
              style={{
                color:
                  statistics?.averagePL > 0
                    ? "var(--blue)"
                    : statistics?.averagePL == 0
                    ? "var(--white)"
                    : "var(--red)",
              }}
            >
              {statistics?.averagePL
                ? statistics?.averagePL.toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                  }) +
                  " " +
                  challengeCurrency
                : statistics?.averagePL == 0
                ? "0.00 " + challengeCurrency
                : "-"}
            </div>
          )}
        </div>
        <div className="flex flex-col  border-2 border-border-darkNew py-2 px-2 rounded-lg gap-2 flex-1 justify-center">
          <div className="text-white-opacity text-sm">
            Best Performing Asset
          </div>
          {getStatisticsLoading || challengeStageInfoLoading ? (
            <Skeleton className="w-16 h-6 " />
          ) : (
            <div className="flex items-baseline gap-2">
              <div className="text-white text-base font-N_Bold">
                {statistics?.highestPerformingAsset?.symbol || "-"}
              </div>
              {statistics?.highestPerformingAsset?.profit ? (
                <div
                  className="text-white  text-xs"
                  style={{
                    color:
                      statistics?.highestPerformingAsset?.profit > 0
                        ? "var(--green)"
                        : "var(--red)",
                  }}
                >
                  {statistics?.highestPerformingAsset?.profit.toLocaleString(
                    "en-US",
                    {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2,
                    }
                  ) +
                    " " +
                    challengeCurrency}{" "}
                  Total Profit
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Statistics;
